import { toPartialQueryString } from '@/utils/parsers/QueryString'
import { IFilterList } from '@/utils/interfaces/FilterListInterface'
import {
    IAuditEntityListEnumDescription,
} from '@/audit/interfaces/AuditInterfaces'
import { IDateRange } from '@/utils/interfaces/DateRangeInterface'

export class AuditMuvenApiListFilterModel implements IFilterList {
    date: IDateRange = { start: null, end: null }
    entityList: IAuditEntityListEnumDescription[] = []

    constructor(o?: Partial<AuditMuvenApiListFilterModel>) {
        Object.assign(this, o)
    }

    isFilterFilled(): boolean {
        return !!this.date.start ||
            !!this.date.end ||
            !!this.entityList.length
    }

    toPartialQueryString(): string {
        const startDate = this.date ? this.date.start as Date : null
        const endDate = this.date ? this.date.end as Date : null

        const tmp = {
            ...this,
            // clear the date object so it isn't used
            // in the querystring
            date: undefined,
            custom: undefined,
            entityList: this.entityList.map((e) => {
                return e.enum
            }),
            startDate: startDate instanceof Date ? startDate.toISOString() : null,
            endDate: endDate instanceof Date ? endDate.toISOString() : null,
        }

        return toPartialQueryString(tmp);
    }
}
